import React from 'react';
import { Heart, ArrowLeft } from 'lucide-react';
import Header from './Header';

function TermsOfService() {
  return (
    
    <div className="min-h-screen bg-gray-50">
      <Header/>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms of Service</h1>
          <p className="text-gray-600 mb-8">Last updated: June 11, 2025</p>

          <div className="prose max-w-none">
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-700 mb-4">
                By accessing and using VineMatched, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Service Description</h2>
              <p className="text-gray-700 mb-4">
                VineMatched is an emotional support platform that connects users with volunteer listeners for peer-to-peer emotional support through text-based conversations. Each session is meant to last up to 20 minutes, but extentions can be made depending on the circumstances. We are NOT a professional mental health service, crisis intervention service, or medical service.
              </p>
              <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-4">
                <p className="text-red-700 font-medium">
                  Important: If you are experiencing a mental health crisis or emergency, please contact your local emergency services (911 in the US) or a professional crisis hotline immediately.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">3. User Conduct and Prohibited Activities</h2>
              <p className="text-gray-700 mb-4">You agree NOT to use the service to:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
                <li>Share, request, or exchange any sexual content, including but not limited to explicit text, images, or media</li>
                <li>Engage in harassment, bullying, or threatening behavior</li>
                <li>Share personal identifying information (full names, addresses, phone numbers, etc.)</li>
                <li>Promote self-harm, suicide, or violence</li>
                <li>Distribute spam, malware, or malicious content</li>
                <li>Impersonate others or create false identities</li>
                <li>Use the platform for commercial purposes without authorization</li>
                <li>Attempt to hack, disrupt, or compromise the platform's security</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Age Requirements</h2>
              <p className="text-gray-700 mb-4">
                You must be at least 13 years old to use VineMatched. Users under 18 should have parental consent. We recommend parental guidance for all minors using the platform.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Privacy and Anonymity</h2>
              <p className="text-gray-700 mb-4">
                We prioritize user privacy and maintain anonymous conversations. However, we may monitor conversations for safety purposes and reserve the right to report illegal activities or imminent threats to appropriate authorities.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Limitation of Liability</h2>
              <p className="text-gray-700 mb-4">
                VineMatched and its volunteers provide emotional support on a peer-to-peer basis. We are not liable for any outcomes resulting from conversations on our platform. Users participate at their own risk and should seek professional help when needed.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Termination</h2>
              <p className="text-gray-700 mb-4">
                We reserve the right to terminate or suspend access to our service immediately, without prior notice, for conduct that we believe violates these Terms of Service or is harmful to other users, us, or third parties.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Changes to Terms</h2>
              <p className="text-gray-700 mb-4">
                We reserve the right to modify these terms at any time. We will notify users of any significant changes via email or platform notification.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Contact Information</h2>
              <p className="text-gray-700 mb-4">
                For questions about these Terms of Service, please contact us at:
                <br />
                <a href="mailto:connect@vinematched.com" className="text-red-600 hover:text-red-700">connect@vinematched.com</a>
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}

export default TermsOfService;